import React from "react";
import logo from "../../assets/logo_white.svg";
import { NXLeftArrow, NXRightArrow } from "../../icons";
import MenuItems from "./MenuItems";

function DesktopMenu({
  sidebarOpen,
  setSidebarOpen,
}: {
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
// const closeSideBar = () => {
  //   setSidebarOpen(false);
  // };

  const toggleSideBar = () => {
    setSidebarOpen((prev) => !prev);
  };

  return (
    <div
      className={`hidden sticky mh:block h-screen custom-scrollbar overflow-auto top-0 left-0 bg-white z-50 border-r border-[#EEEFF2] transition-all ease-in-out duration-500 ${
        sidebarOpen ? "w-[65px]" : "w-[230px]"
      }`}
    >
      {/* desktop screen sidebar collapse button */}
      <button
        className={`shadow-lg m border-2 border-slate-200 hidden mh:block mh:fixed mh:z-[100] transition-all ease-in-out duration-300 ${
          sidebarOpen ? "left-[63px] rounded-l-none" : "left-[185px]"
        } top-8 text-gray-200 bg-[#0CAF60] w-7 aspect-square rounded-full`}
        onClick={toggleSideBar}
      >
        {sidebarOpen ? <NXRightArrow /> : <NXLeftArrow />}
      </button>

      <div className="flex items-center justify-between">
        {!sidebarOpen ? (
          <img
            src={logo}
            alt="NXTBN logo"
            className="w-[100px] mh:w-[120px] my-7 mx-5 p-2 transition-all duration-300 rounded-full"
            style={{ backgroundColor: "rgb(39, 114, 0)" }}
          />
        ) : (
            <p
            className="w-[40px] h-[40px] my-7 mx-5 p-2 flex items-center justify-center text-white text-lg font-bold rounded-full"
            style={{ backgroundColor: "rgb(39, 114, 0)" }}
            >
            S
            </p>
        )}
      </div>

      <p
        className={`pb-2 text-base-200 text-[12px] transition-all duration-300 ${
          sidebarOpen ? "px-4" : "px-5"
        }`}
      >
        MENU
      </p>

      <MenuItems sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
    </div>
  );
}

export default DesktopMenu;

